import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export const emptyL = { id: "", en: "" };

/** Paired ID/EN input used across the Education CMS. */
export function Bilingual({ label, value, onChange, testId, rows = 0 }) {
  const Control = rows ? Textarea : Input;
  return (
    <div className="space-y-1.5">
      <Label className="text-slate-300 text-xs">{label}</Label>
      <div className="grid sm:grid-cols-2 gap-2">
        {["id", "en"].map((lc) => (
          <div key={lc} className="space-y-1">
            <span className="text-[10px] uppercase tracking-widest text-slate-500">{lc === "id" ? "🇮🇩 ID" : "🇬🇧 EN"}</span>
            <Control
              data-testid={`${testId}-${lc}`}
              rows={rows || undefined}
              value={value?.[lc] || ""}
              onChange={(e) => onChange({ ...value, [lc]: e.target.value })}
              className="bg-[#1C202E] border-white/10 text-white text-sm"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
